var URL_BANNERWEBLOGOS = "https://app01.grupomhautomotriz.com/integradmsws/Logos/BannerImages/";
var URL_SITIOSWEBBANNER = "https://app01.grupomhautomotriz.com/integradmsws/Documentos/Banner/";
var URL_SITIOSWEB = "Logos/SitiosWeb/";
var URL_WHYCAR4U = "Logos/why-car4you/";
var URL_SITIOSWEBRAZONES = "https://app01.grupomhautomotriz.com/integradmsws/Logos/SitioWebRazon/";
var URL_SITIOSWEBPROMOCIONES = "http://localhost:64483/Logos/Promociones/";
var URL_INVENTARIO = "Documentos/Inv/";
var URL_NOSOTROS = "Logos/Nosotros/";
var URL_CONTACTO = "Logos/Contacto/";
var URL_RECIBO = "https://app01.grupomhautomotriz.com/integradmsws/Documentos/recibos/";

export default {
  URL_BANNERWEBLOGOS,
  URL_SITIOSWEB,
  URL_SITIOSWEBBANNER,
  URL_WHYCAR4U,
  URL_SITIOSWEBRAZONES,
  URL_INVENTARIO,
  URL_NOSOTROS,
  URL_CONTACTO,
  URL_RECIBO,
  URL_SITIOSWEBPROMOCIONES,
};